import React from 'react';
import Table from '../../app-components/table/Table';
import {listUri} from '../../Queries';
import {removeData} from '../../AppServices';
import {colors} from '../../theme/colors';
import {h14_AvenirNext, h12_Regular} from '../../theme/fonts';
import {Text} from '../../app-components';

const {backdropColor70} = colors;

let uri = () => {
  return listUri({model: 'SocialHistories', id: 'socialHistoryLists'});
};
const tableData = {
  lg: {
    columns: [
      {
        width: 50,
      },
      {
        render: (props) => {
          return <Text style={{...h12_Regular}}>{props.index + 1}</Text>;
        },
        header: 'S.No.',
        width: 150,
      },
      {
        type: 'text',
        field: 'name',
        header: 'Name',
        key: 'index',
      },
    ],
    hoverActions: [
      {
        value: 'Edit',
        align: 'right',
        textStyle: {
          color: '#9a9a9a',
          fontWeight: 500,
          ...h14_AvenirNext,
          paddingTop: 15,
        },
        action: ({item}) => {
          return {
            type: 'link',
            link: {
              view: 'edit-social-history',
              params: {item},
            },
          };
        },
      },
      {
        value: 'Delete',
        position: 'center',
        align: 'right',
        textStyle: {
          color: 'rgb(241,79,79, 0.87)',
          fontWeight: 500,
          ...h14_AvenirNext,
          paddingTop: 15,
          paddingLeft: 10,
        },
        action: {
          type: 'link',
          link: (props) => {
            let {item} = props;
            return {
              view: 'delete-masterData',
              modal: true,
              params: {
                item,
                label: 'Social History',
                deleteAction: () => removeData({item, model: 'SocialHistories'}),
                reloadEvent: 'reloadSocial',
              },

              modalProps: {
                autoHide: true,
                height: 250,
                backdropColor: backdropColor70,
              },
            };
          },
        },
      },
    ],
  },
  sm: {
    columns: [
      {
        render: (props) => {
          return <Text style={{...h12_Regular}}>{props.index + 1}</Text>;
        },
        header: 'S.No.',
        width: 50,
      },
      {
        type: 'text',
        field: 'name',
        header: 'Name',
        key: 'index',
      },
      {
        type: 'moreActions',
        width: 50,
        actions: [
          {
            text: 'Edit',
            align: 'right',
            textStyle: {
              color: '#9a9a9a',
              fontWeight: 500,
              ...h14_AvenirNext,
            },
            action: ({item}) => {
              return {
                type: 'link',
                link: {
                  view: 'edit-social-history',
                  params: {item},
                },
              };
            },
          },
          {
            text: 'Delete',
            position: 'center',
            align: 'right',
            textStyle: {
              color: 'rgb(241,79,79, 0.87)',
              fontWeight: 500,
              ...h14_AvenirNext,
            },
            action: {
              type: 'link',
              link: (props) => {
                let {item} = props;
                return {
                  view: 'delete-masterData',
                  modal: true,
                  params: {
                    item,
                    label: 'Social History',
                    deleteAction: () => removeData({item, model: 'SocialHistories'}),
                    reloadEvent: 'reloadSocial',
                  },

                  modalProps: {
                    autoHide: true,
                    height: 250,
                    backdropColor: backdropColor70,
                  },
                };
              },
            },
          },
        ],
      },
    ],
  },
};
export default Table({
  uri,
  ...tableData,
  reloadEvent: 'reloadSocial',
});
